import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { get } from "common/helpers/HTTP";

import { useCampaignContext } from "../context/CampaignContext";

import type { LinkedInPost } from "../types";

async function getLinkedInPost(
  workspaceId: string,
  campaignId: string,
  postId: string,
): Promise<LinkedInPost> {
  return (
    await get(
      `workspaces/${workspaceId}/campaigns/${campaignId}/posts/${postId}`,
    )
  ).post;
}

export default function useLinkedInPost(postId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { id: campaignId } = useCampaignContext();

  const {
    data: linkedInPost,
    isLoading: isLoadingLinkedInPost,
    isError: isLinkedInPostError,
  } = useQuery({
    queryKey: ["linkedInPost", postId],
    queryFn: () => getLinkedInPost(workspaceId, campaignId, postId),
    enabled: !!postId,
    gcTime: 0,
  });

  return {
    linkedInPost,
    isLoadingLinkedInPost,
    isLinkedInPostError,
  };
}
